module.exports = __webpack_public_path__ + "static/img/AdobeStock_288540788.785210c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/AdobeStock_288540788.jpeg
// module id = 1517
// module chunks = 5